/**
 * Add product to basket
 * @param basket
 * @param uuid
 * @returns {*}
 */
const addToBasket = (basket, uuid) => {
  if (!basket[uuid]) {
    return Object.assign({}, basket, {
      [uuid]: {
        quantity: 1,
        openValue: null
      }
    })
  }

  return Object.assign({}, basket, {
    [uuid]: {
      quantity: ++basket[uuid].quantity,
      openValue: null
    }
  })
}

const addOpenValueToBasket = (basket, uuid, value) => {
  return Object.assign({}, basket, {
    [uuid]: {
      quantity: 1,
      openValue: value
    }
  })
}

/**
 * Remove product from basket
 * @param basket
 * @param uuid
 * @returns {*}
 */
const removeFromBasket = (basket, uuid) => {
  const copiedBasket = Object.assign({}, basket)
  if (basket[uuid].quantity === 1) {
    delete copiedBasket[uuid]
  } else {
    --copiedBasket[uuid].quantity
  }
  return copiedBasket
}

export {
  addToBasket,
  removeFromBasket,
  addOpenValueToBasket
}
